module.exports = __webpack_public_path__ + "static/media/doc-pic-4.6c5a38aa.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/resources/doc-pic-4.JPG
// module id = 87
// module chunks = 0